import React, { useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import moment from 'moment';
import { FixedSizeList } from 'react-window';
import GeofenceIcon from './img/geofenceAlert.svg';
import UnpluggedIcon from './img/unpluggedStatusAlert.svg';
import AssetStatusIcon from './img/assetStatusAlert.svg';
import OverspeedingIcon from './img/overspeedingAlert.svg';
import BatteryStatusIcon from './img/batteryStatusAlert.svg';
import EvRangeIcon from './img/evRangeAlert.svg';
import EVBatteryTempICon from './img/evBatteryTemperatureAlert.svg';
import EVBatteryStateOfHealthIcon from './img/batteryHealthAlert.svg';
import ColoredLine from '../coloredLine/ColoredLine';
import UnreadIcon from './img/unread.svg';
import NotificationIcon from './img/Notification.svg';
import EVChargingIcon from './img/evChargingAlert.svg';
import { TextButton } from '../buttonComponent/ButtonComponent';
import { APIGetAlerts } from '../../config/restAPI/FetchAPI';
import { APIPatchAlerts } from '../../config/restAPI/PatchAPI';
import './NotificationFeed.css';

const NotificationFeed = (props) => {
    const token = Cookies.get('jwtToken');
    const agencyID = Cookies.get('agencyUUID');
    const role = Cookies.get('role');
    const { data, setData, fetchAlerts } = props;
    const [loading, setLoading] = useState(false);
    const [emptyState, setEmptyState] = useState(false);

    useEffect(() => {
        if (data) {
            if (data.filter((x) => x.read === false).length === 0) {
                setEmptyState(true);
            } else {
                setEmptyState(false);
            }
        } else {
            setEmptyState(true);
        }
    }, [data]);

    const markAlertAsRead = async (oids) => {
        const params = {
            input: {
                oids: [oids],
                read: true,
            },
        };
        try {
            const result = await APIPatchAlerts(token, setLoading, agencyID, params);
            if (result?.data?.status === 200) {
                setLoading(false);
                fetchAlerts();
            }
        } catch (err) {
            setLoading(false);
        }
    };

    const checkAlertType = (type) => {
        switch (type) {
            case 101:
                return 'Geofence Alert';
            case 102:
                return 'Unplugged Status Alert';
            case 103:
                return 'Asset Status Alert';
            case 104:
                return 'Speeding Alert';
            case 105:
                return 'Battery Status Alert';
            case 106:
                return 'EV Range Alert';
            case 107:
                return 'EV Charging Alert';
            case 108:
                return 'EV Battery Temperature Alert';
            case 109:
                return 'EV Battery SoH Alert';
            default:
                return null;
        }
    };

    // Helper function to get icon and alt text
    const getIconAndAlt = (type) => {
        switch (type) {
            case 101:
                return { icon: GeofenceIcon, alt: 'geofence-alert-icon' };
            case 102:
                return { icon: UnpluggedIcon, alt: 'unplugged-alert-icon' };
            case 103:
                return { icon: AssetStatusIcon, alt: 'asset-status-alert-icon' };
            case 104:
                return { icon: OverspeedingIcon, alt: 'speeding-alert-icon' };
            case 105:
                return { icon: BatteryStatusIcon, alt: 'battery-status-alert-icon' };
            case 106:
                return { icon: EvRangeIcon, alt: 'ev-range-alert-icon' };
            case 107:
                return { icon: EVChargingIcon, alt: 'ev-charging-alert-icon' };
            case 108:
                return { icon: EVBatteryTempICon, alt: 'battery-temperature-alert-icon' };
            case 109:
                return { icon: EVBatteryStateOfHealthIcon, alt: 'ev-battery-state-of-health-alert-icon' };
            default:
                return { icon: null, alt: 'default-icon' };
        }
    };

    return (
        <div className="notification-feed-container">
            <div className="notification-feed-header">
                Notifications
            </div>
            <div className="notification-feed-content">
                {emptyState ? (
                    <div className="notification-feed-empty-state">
                        <img src={NotificationIcon} alt="empty-notification-icon" loading="lazy" />
                        <div className="notification-feed-empty-body">
                            <div className="notification-feed-empty-header">
                                No Unread Notifications
                            </div>
                            <div className="notification-feed-empty-subtext">
                                You are all caught up
                            </div>
                        </div>
                    </div>
                ) : (
                    <>
                        {data && data.map((x) => x.read === false && (
                            <React.Fragment key={x.oid}>
                                <div className="notification-feed-item">
                                    <img
                                      src={getIconAndAlt(x.type).icon}
                                      loading="lazy"
                                      alt={getIconAndAlt(x.type).alt}
                                    />
                                    <div className="notification-feed-item-content">
                                        {x.read === false && (
                                            <img src={UnreadIcon} alt="unread-icon" loading="lazy" className="unread-icon-feed-item" />
                                        )}
                                        <div className="notification-feed-item-container">
                                            <div className="notification-feed-item-header">
                                                <div className="notification-feed-item-type">
                                                    {checkAlertType(x.type)}
                                                </div>
                                                <div className="notification-feed-item-timestamp">
                                                    {moment(x.timestamp).fromNow()}
                                                </div>
                                            </div>
                                            <div className="notification-feed-item-body">
                                                {x.message}
                                            </div>
                                        </div>
                                        <div>
                                            <TextButton
                                              label="Mark as read"
                                              onClickFunction={() => markAlertAsRead(x.oid)}
                                              fontWeight="600"
                                              color="#26404E"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <ColoredLine />
                            </React.Fragment>
                        ))}
                    </>
                )}
            </div>
        </div>
    );
};

export default NotificationFeed;
